// extracted by mini-css-extract-plugin
module.exports = {"imageLink":"image-link-module--image-link--77jYj"};